import * as React from "react";
const coinsSizes = ["big", "medium", "small"];
export function Coin(props) {
    const { positionLeft, rotation, delay } = props;
    const size = coinsSizes[Math.floor(Math.random() * coinsSizes.length)];
    const coinWrapperStyles = {
        left: `${positionLeft}%`,
        animationDelay: `${delay}ms`
    };
    const coinStyle = {
        transform: `rotate(${rotation}deg)`
    };
    return (React.createElement("div", { className: `rj-jackpot-winning-animation__coin-wrapper rj-jackpot-winning-animation__coin-${size}`, style: coinWrapperStyles },
        React.createElement("div", { className: "rj-jackpot-winning-animation__coin", style: coinStyle })));
}
//# sourceMappingURL=Coin.js.map